module.exports = __webpack_public_path__ + "static/media/heartipro-charger-4.ee4b3dd9.png";